import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-info-group',
    templateUrl: './info-group.component.html',
    styleUrls: ['./info-group.component.less']
})
export class InfoGroupComponent {
    @Input() title: string;
}
